<template>
  <transition name="slide">
    <modal :open="isOpen" :title="createTitle" @cancel="cancel" @save="save">
      <field
        :required="true"
        :errors="errors"
        model="external_form"
        name="name"
        v-model="item.name"
        placeholder="Form Name"
      />
      <field
        :required="true"
        :errors="errors"
        model="external_form"
        name="language"
        type="radio"
        v-model="item.language"
        :collection="languageGetter"
        :defaultValue="currentLanguage"
      />
      <field
        :required="true"
        :errors="errors"
        model="external_form"
        v-can="'projects.list'"
        name="project_id"
        v-model="item.project_id"
        type="select"
        :params="{ no_i18n: true }"
        :collection="projects"
      />
    </modal>
  </transition>
</template>
<script>
import { EventBus } from "@/EventBus";
import Field from "@helpers/DataInput/Field";
import ProjectApi from "@/api/Project";
import ExternalFormApi from "@/api/ExternalForm";
import Languages from "@/config/data/languages";
import Modal from "@/components/helpers/Layout/NewModal";

export default {
  components: {
    Modal,
    Field
  },
  props: ["language"],
  data() {
    return {
      isOpen: false,
      item: {},
      errors: [],
      projects: [],
      languages: Languages
    };
  },
  computed: {
    currentLanguage() {
      return this.$store.getters.getCurrentLanguage;
    },
    languageGetter() {
      let language = this.currentLanguage || "en";
      let translatedLangs = [];
      let selectedLanguage = this.languages[language];

      if (!selectedLanguage) {
        selectedLanguage = this.languages['en']
      }

      selectedLanguage.forEach(lang => {
        translatedLangs.push(lang);
      });
      return translatedLangs;
    },
    createTitle() {
      return this.$t("ui.pages.external-forms-create-button");
    }
  },
  mounted() {
    EventBus.$on("action", this.handleAction);
    this.retrieve_projects();
    EventBus.$on("open", open => {
      this.isOpen = true;
    });
  },
  methods: {
    async create() {
      let api = new ExternalFormApi();
      let item = this.initItem(this.item);

      try {
        item = await api.post(item);
        this.$store.commit("SET_NOTIFICATION", {
          title: "models.external_form.message.create",
          type: "success"
        });
        this.$router.push({
          name: "external_form_edit",
          params: { id: item.id }
        });
      } catch (err) {
        this.errors = err.response.data.errors;
      }
    },
    initItem(item) {
      item.additional_data = {};
      item.configuration = {};
      let structure = {
        submit_button: {
          content: "Submit",
          element_type: "submit",
          name: "submit_button",
          parent_element: "root",
          position: "0",
          hidden: false,
          class: ""
        }
      };

      item.structure = structure;
      return item;
    },
    handleAction(action) {
      if (action == "external_form.add_popup") {
        this.isOpen = true;
      }
    },
    retrieve_projects() {
      let api = new ProjectApi();
      api
        .all_for_association("name", {
          sort_by: "updated_at",
          sort_order: "DESC"
        })
        .then(items => {
          this.projects = items;
        })
        .catch(function(error) {});
    },
    cancel() {
      this.isOpen = false;
    },
    async save() {
      await this.create();
      if (this.errors.length == 0) {
        this.isOpen = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.modal-box--content {
  padding: 3em 2em;
}
.modal-box-external-form-create {
  &.modal-box-wrapper {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    transition: opacity 0.15s ease-out;
    overflow: hidden;
    z-index: 10;
    &.slide-enter,
    &.slide-leave-to {
      opacity: 0;
    }
    .modal-box {
      min-width: 450px;
    }
  }

  // fields
  .field--input,
  .field-select {
    font-size: 1em;
    margin-bottom: 0;
  }
  .input--select-wrapper:after {
    line-height: 1em;
    height: 1em;
  }
  .is-inline {
    display: flex;
    .field--input,
    .field-select {
      min-width: 200px;
    }
  }
  .form-switch {
    display: flex;
    justify-content: space-between;
    label {
      font-size: 1em;
      font-weight: 200;
    }
  }
  .is-inline label {
    display: inline-block;
    align-self: center;
    margin-right: 10px;
    margin-top: 0;
    min-width: 150px;
  }
  label .optional {
    display: none;
  }

  .actions {
    margin-top: 10px;
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// ExternalFormCreate.vue?a1bfe3e4